<template>
  <div class="layout">
    <header-bar></header-bar>
    <div class="navwrap"></div>
    <div class="med-wrapper-box">
      <div>
        <Content class="m-content-wrapper">
          <router-view></router-view>
        </Content>
      </div>
    </div>
  </div>
</template>
<script>
import headerBar from "./GuestHeaderBar.vue";
export default {
  name: "mainFrame",
  components: {
    headerBar,
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {},
  props: {},
  methods: {
  }
};
</script>

<style scoped>
.med-wrapper-box{
    min-height: 400px;
}
</style>